import { countries } from "@up/form";

export function CountryOptions() {
  const userAgent = window?.navigator.userAgent;
  const hideFlags =
    userAgent?.includes("Chrome") && userAgent?.includes("Windows");

  return (
    <>
      {[...countries]
        .sort((a, b) => {
          if (a.code === "US") return -1;
          if (b.code === "US") return 1;
          return a.code.localeCompare(b.code);
        })
        .map((country) => (
          <option key={country.code} value={country.code}>
            {`${country.code} ${hideFlags ? "" : country.emojiFlag} ${country.dialCode}`}
          </option>
        ))}
    </>
  );
}
